import React, { useContext, useEffect, useState } from 'react';
import { Button, Checkbox, Paper, Tab, Tabs } from '@material-ui/core';

import { shippingApi } from 'api/shipping';
import { UserContext } from 'contexts/UserContext';
import { DataTable, FormComponent, Notifications, TabPanel } from 'shared';
import dayjs from 'utils/dayjsConfig';

function PrintLabels() {
    const [selectedTab, setSelectedTab] = useState('0');
    const [notification, setNotification] = useState({ text: '', level: null });
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Notifications options={notification} />
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="VIPShipments_Tab" label="VIP shipments" value="0" />
                <Tab id="PrintLabel_Tab" label="Print Label" value="1" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <VipOrders setNotification={setNotification} />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <PrintLabel setNotification={setNotification} />
            </TabPanel>
        </Paper>
    );
}

function PrintLabel({ setNotification }) {
    return (
        <div style={{ height: '100%' }}>
            <h3>Print Label</h3>
            <FormComponent
                formFields={[
                    {
                        name: 'shipmentID',
                        inputElement: 'textField',
                        label: 'Shipment ID',
                        gridValue: 12,
                        inputProps: { required: true },
                    },
                ]}
                onSubmit={async (formData, resetForm) => {
                    const res = await shippingApi.downloadLPN(formData.shipmentID);
                    if (res === true) {
                        resetForm();
                    } else {
                        setNotification({ text: 'Error getting shipping label', level: 'error' });
                    }
                    return res;
                }}
            />
        </div>
    );
}

function VipOrders({ setNotification }) {
    const [unprintedRows, setUnprintedRows] = useState([]);
    const [printedRows, setPrintedRows] = useState([]);
    const user = useContext(UserContext);
    const [facilityID, setFacilityID] = useState(user.getFacilityID());

    const getUnprintedVIPOrders = async () => {
        const result = await shippingApi.getVipShipments(true, facilityID);
        if (result.status === true) {
            setUnprintedRows(
                result.data.shipments.map((item) => {
                    item.shipment.createdAt = dayjs(item.shipment.createdAt.date).local().format('MM/DD/YYYY');
                    return item;
                }),
            );
        }
    };
    const getPrintedVIPOrders = async () => {
        const result = await shippingApi.getVipShipments(false, facilityID);
        if (result.status === true) {
            setPrintedRows(
                result.data.shipments.map((item) => {
                    item.shipment.createdAt = dayjs(item.shipment.createdAt.date).local().format('MM/DD/YYYY');
                    return item;
                }),
            );
        }
    };
    const handlePrintedChange = async (printed, id) => {
        if (printed) {
            const res = await shippingApi.markVipOrderPrinted(id);
            if (res.status === true) {
                getPrintedVIPOrders();
                getUnprintedVIPOrders();
            }
        }
    };

    useEffect(() => {
        getUnprintedVIPOrders();
        getPrintedVIPOrders();
    }, []);

    const columns = [
        { accessor: 'shipment.id', Header: 'ID' },
        { accessor: 'shipment.status', Header: 'Status' },
        { accessor: 'shipment.createdAt', Header: 'Created Date' },
        { accessor: 'shipment.shopifyOrderNumber', Header: 'Order Number' },
        { accessor: 'lineHaul.carrier', Header: 'Carrier' },
        { accessor: 'lineHaul.hub', Header: 'Hub' },
        { accessor: 'lineHaul.arrivalDay', Header: 'Pack Day' },
        { accessor: 'lineHaul.arrivalHour', Header: 'Arrival Hour' },
        {
            accessor: 'linkToPDF',
            Header: 'PDF',
            Cell: ({ cell: { value: initialValue }, column, editable, row, saveEdit }) => (
                <Button
                    className="download-link"
                    onClick={async () => {
                        const res = await shippingApi.downloadLPN(row.original.shipment.id);
                        if (res !== true) {
                            setNotification({ text: 'Error getting shipping label', level: 'error' });
                        }
                        getUnprintedVIPOrders();
                        getPrintedVIPOrders();
                    }}
                >
                    Download
                </Button>
            ),
        },
        {
            accessor: 'printed',
            Header: 'Printed',
            Cell: ({ cell: { value: initialValue }, column, editable, row, saveEdit }) => {
                const printed = row.original.shipment.status !== 'LABEL_PURCHASED';
                return (
                    <div>
                        <Checkbox
                            checked={printed}
                            onChange={(event) => {
                                handlePrintedChange(!printed, row.original.shipment.id);
                            }}
                            value="primary"
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                        />
                    </div>
                );
            },
        },
    ];
    return (
        <div>
            <DataTable title="Ready To Print" columns={columns} data={unprintedRows} editable={false} />

            <DataTable title="Printed" columns={columns} data={printedRows} editable={false} />
        </div>
    );
}

export { PrintLabels };
